module.exports = __webpack_public_path__ + "img/luna llena.5c4c875c.png";